import script from "./accountManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./accountManagement.vue?vue&type=script&setup=true&lang=js"

import "./accountManagement.vue?vue&type=style&index=0&id=72aa0186&lang=less"
import "./accountManagement.vue?vue&type=style&index=1&id=72aa0186&lang=less&scoped=true"

import exportComponent from "D:\\CODE\\joyjobs_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72aa0186"]])

export default __exports__